<template>
  <div v-if="loading" class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

</template>

<script>
    export default {
        name: "BaseLoader",
        props: {
            loading: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
            };
        },
    };
</script>

<style scoped lang="scss">

</style>
